<template>
  <section class="container mx-auto mb-10">
    <h2 class="text-xl mb-1"><slot name="title"></slot></h2>
    <p class="text-gray-500 mb-2"><slot name="description"></slot></p>
    <div class="bg-white rounded shadow p-8">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script>

export default {
  name: 'XtraSection'
}

</script>



// WEBPACK FOOTER //
// src/components/layouts/sections/extra-layout.vue